"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Anushavan.Hovsepyan
 * on 9/19/2016.
 */
var core_1 = require("@angular/core");
require("./sis-tag.component.css");
var Tag = /** @class */ (function () {
    function Tag() {
        this.isRemovable = true;
        /**
         * Delete tag action.
         * @type {EventEmitter}
         */
        this.tagDeleteAction = new core_1.EventEmitter();
    }
    Tag.prototype.onDeleteTag = function (id) {
        this.tagDeleteAction.emit(id);
    };
    Object.defineProperty(Tag.prototype, "seleniumTestClass", {
        get: function () {
            return this.id + "-tooltip";
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], Tag.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Tag.prototype, "label", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], Tag.prototype, "details", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], Tag.prototype, "tagDeleteAction", void 0);
    Tag = __decorate([
        core_1.Component({
            
            selector: "sis-tag",
            template: require('./sis-tag.component.html'),
            encapsulation: core_1.ViewEncapsulation.None
        })
        /**
         * Tag control, which get tag id and label, and show it.
         * Tag control is deletable.
         */
    ], Tag);
    return Tag;
}());
exports.Tag = Tag;
//# sourceMappingURL=sis-tag.component.js.map